var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var AlarmActionService = /** @class */ (function () {
    function AlarmActionService() {
        this.alarmTriggeredName = 'Trigger';
        this.alarmConfirmName = 'Confirm';
        this.alarmRecoverName = 'Recover';
    }
    AlarmActionService.prototype.getActionName = function (action) {
        switch (action) {
            case 1:
                return this.alarmTriggeredName;
            case 2:
                return this.alarmConfirmName;
            case 3:
                return this.alarmRecoverName;
            default:
                return null;
        }
    };
    AlarmActionService = __decorate([
        Injectable()
    ], AlarmActionService);
    return AlarmActionService;
}());
export { AlarmActionService };
